import { FormattedMessage} from 'react-intl';
import Form from '../../../../../ui/Form';
import Input from '../../../../../ui/Input';
import React from 'react';


export const renderField = allProps => {

    /* eslint no-unused-vars: ["off", { "ignoreRestSiblings": true }] */
    const { size, ...props } = allProps;

    props.input.id = (props.id || props.input.name);

    return (
        <Form.Control erroneous={!!props.error}>
            {props.label !== false && (
                <Form.Label htmlFor={props.input.name} required={props.required}>
                    <FormattedMessage
                        id={props.label || props.input.name}
                    />
                </Form.Label>
            )}
            <Input {...props.input} type={props.type}/>
            {props.hint && (
                <Form.Hint>
                    <FormattedMessage id={props.hint} />
                </Form.Hint>
            )}
            {props.error && (
                <Form.Error>
                    {props.error}
                </Form.Error>
            )}
        </Form.Control>
    );
};

